import axios from 'axios';
import queryString from 'query-string';

const server_url = process.env.REACT_APP_SERVER_URL;

const convertAssetUrl = async (token, dataUrl) => {
  return await axios
    .post(`${server_url}/api/assets/customer/convert`, dataUrl, {
      headers: { authorization: `Bearer ${token}` }
    })
    .then(function (response) {
      return response
    })
    .catch(function (error) {
      return error.response
    })
}

export {
  convertAssetUrl
}
